jQuery(document).ready(function($) {

    ////////////////////////////////
    //  Email - Parse JavaScript  //
    ////////////////////////////////

    $("a.safe").each( function () {
        // Build mail adrees from data-pre and data-post attributes, add as href and node content, and remove target attribute
        $(this).attr('href', 'mailto:' + $(this).data('pre') + '@' + $(this).data('post')).html($(this).data('pre') + '@' + $(this).data('post')).removeAttr('target');
    });

    ///////////////////////////////////
    //  Projects - hero image scroll //
    ///////////////////////////////////
    
    // If on featured projects or single project page
    if ($('.project-featured-image').length > 0) {

        // Settings
        var outerElementClass = ".project-featured-image";
        var innerElementClass = ".hero-image";
        var outerElementHeight = 700;
        var innerElementHeight = 900;

        // Cache jQuery object of featured projects
        $outerElements = $(outerElementClass);

        // Background
        function adjustProjectBackgrounds() {

            var windowTopOffset = $(this).scrollTop();
            var windowHeight = $(window).height();

            // Check if in view
            $outerElements.each(function() {
                
                // If element top y is less than scroll Y plus viewport height, element is over browser bottom edge
                // console.log($(this).offset().top + " < " + windowTopOffset + " + " + windowHeight + "= ");
                var elementTopOffset = $(this).offset().top;
                var elementHeight = $(this).height();

                // console.log("Over: " + ($(this).offset().top < (windowTopOffset + windowHeight)));
                // console.log("Under: " +  (($(this).offset().top + $(this).height()) > windowTopOffset));
                var isOverBottom =  elementTopOffset < (windowTopOffset + windowHeight);
                var isUnderTop =  (elementTopOffset + elementHeight) > windowTopOffset;
                
                // If item is over or under, ignore 
                if (isOverBottom && isUnderTop) {
                    var backgroundAdjustment = ((((windowTopOffset - elementTopOffset) + windowHeight)) / (elementHeight + windowHeight));
                    $(this).find(innerElementClass).css('top', '-' + (backgroundAdjustment * (innerElementHeight - outerElementHeight)) + 'px');
                }
            })
            // $(this).css('background-position', '0% ' + parseInt(-x / 10) + 'px');
        }

        $(window).scroll(function() {
            adjustProjectBackgrounds();
        });

        adjustProjectBackgrounds();
    }


    /////////////////////////////////////////////////////////////
    //  PhotoSwipe Gallery - initiate if gallery is on screen  //
    /////////////////////////////////////////////////////////////

    if ($('.gallery').length > 0) {

        function initPhotoSwipe() {
            // console.log('initPhotoSwipe');
            var item;
            var items = [];
            var pswpElement = document.querySelectorAll('.pswp')[0];
            var elements = document.getElementsByClassName("gallery__link");

            // read images to array
            for (var i = 0; i < elements.length; i++) {

                var size = elements[i].getAttribute('data-size').split('x');
                var caption = elements[i].getAttribute('data-caption');

                // create slide object
                item = {
                    src: elements[i].getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10),
                    title: caption
                };	

                items.push(item);

                // image click
                elements[i].addEventListener("click", function(e) {

                    e.preventDefault();

                    var that = this;
                    var imgIndex = that.children[0].getAttribute('data-index');

                    // define options
                    var options = {
                        bgOpacity: "0.9",
                        showHideOpacity: true, // hide in-animation since thumbnails has different aspect ratio than large image (if remove, also uncomment "msrc" below)
                        showAnimationDuration: 0,
                        index: imgIndex-1,
                        getThumbBoundsFn: function() {
                            // See Options -> getThumbBoundsFn section of documentation for more info
                            var thumbnail = that.children[0], // find thumbnail
                                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                                rect = thumbnail.getBoundingClientRect(); 

                            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                        }			    
                    };


                    // Initializes and opens PhotoSwipe
                    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
                    gallery.init();


                    // Add event listeners
                    /*
                    gallery.listen('close', function() { 
                        trackEvent('media', 'image gallery', 'close', 0, 0)
                    });

                    gallery.listen('afterChange', function() { 
                        console.log("change");
                        trackEvent('media', 'image gallery', 'navigate', 0, 0)
                    });
                    */

                });

            }
        }
        
        initPhotoSwipe();
        
    }

    /////////////////////////////////////////////
    //  MixItUp project gallery search filter  //
    /////////////////////////////////////////////

    
    if ($("#mixitup").length > 0) {
        // console.log('mixitup');

        // Initialize sortable employees
        function initMixItUp() {

            // Set up mixer object
            var mixer = mixitup('#mixitup', {
                animation: {
                    duration: 300,
                    effects: 'fade stagger(10ms)',
                    easing: 'ease'
                },
                callbacks: {
                    onMixStart: function(state) {

                        if ($matching.length > 0 ) {
                            $("#no-hits p").fadeOut();
                        }
                        
                    },

                    onMixEnd: function(state) {
                    //console.log($matching.length);

                        //setInterval(function(){ 
                            if ($matching.length === 0 ) {
                                $("#no-hits p").fadeIn();                                    
                            }
                        //}, 2000);
                       
                    },

                    onMixFail: function(state) {
                        
                        //setInterval(function(){ 
                            if ($matching.length === 0 ) {
                                $("#no-hits p").fadeIn();                                    
                            }
                        //}, 2000);
                
                    }
                }
            });

            // searchable filter
            // http://codepen.io/edprats/pen/pzAdg
            var inputText;
            var $matching = $();

            // Delay function
            var delay = (function(){
                var timer = 0;
                return function(callback, ms){
                    clearTimeout (timer);
                    timer = setTimeout(callback, ms);
                };
            })();

            $("#search-filter").keyup(function(e){

                    // console.log($(this).attr('id') + ' keyup triggered reset');

                    // Delay function invoked to make sure user stopped typing
                    delay(function() {

                        var currentValue = e.target.value;

                        // reset other selections if not already reset
                        //if ($("#select-department")[0].selectedIndex !== 0) {
                            
                            // $("#select-department")[0].selectedIndex = 0;
                            // $("#select-department").select2("val", "0");    

                            // Reset this value
                            // $("#search-filter").val(currentValue);

                            // Reset this value
                            // $("#search-filter").val(currentValue);

                        //}

                        // Store input text
                        inputText = $("#search-filter").val().toLowerCase();

                        // Check to see if input field is empty
                        
                        if ((inputText.length) > 0) {    

                            $('.mix').each(function() {
                                // $this = $("this");
                                
                                // add item to be filtered out if input text matches the search filter keywords
                                // console.log($(this).find('.name').text() + ' - ' + inputText); // .children('.name').text().toLowerCase()
                                if($(this).find('.search-filter-keywords').text().toLowerCase().match(inputText)) {
                                    $matching = $matching.add(this);
                                }

                                else {
                                    // removes any previously matched item
                                    $matching = $matching.not(this);
                                }
                            });
                            
                            // Show "no results" error if no hits
                            mixer.filter($matching);    
                            
                        }
                        
                        else {
                            // resets the filter to show all item if input is empty
                            // $("#mixitup").mixItUp('filter', 'all');
                            //console.log('filtering all')
                            $('.mix').each(function() {$matching = $matching.add(this)});
                            mixer.filter('all');
                        }
                    }, 200 );
            
            }); //$("#search-filter").keyup(function END 
            
           

        };

        initMixItUp();
    }


    /*
    //////////////////////
    //  Cookie warning  //
    //////////////////////

    // Show cookie warning if not closed before
    if (document.cookie.indexOf("cookieaccepted") < 0) {
        $(".cookiebox").show();
    }

    // Remove cookie warning and remember
    window.setCookieAccepted = function() {
        document.cookie = "cookieaccepted=true; expires=Fri, 3 Aug 2025 12:00:00 UTC; path=/"
        var e = document.getElementsByClassName("cookiebox")[0];
        e.parentNode.removeChild(e);
    }
    */
});

////////////////////
//  Gravity Forms //
////////////////////

// After gform javascript loaded
jQuery(document).on('gform_post_render', function(event, form_id, current_page){
    // Overwrite the error message object with empty string to suppress "max file number reached" error message
    gform_gravityforms.strings.max_reached = '';
});


///////////////////////////////////////////////////
//  Full width row adjustment out of parent divs //
///////////////////////////////////////////////////

/*
jQuery(document).ready(function() {
    
    console.log('dom ready');
        
    function adjustToFullWidthRow() {
  
        // offset elements with class name 'full-width-row-js' to left 0 / right 0
        // to make it work you also need the css class .full-width-row-js in global.scss
        
        jQuery('.full-width-row-js').each(function() {
            jQuery(this).offset({
                left: 0,
                right: 0
            });
        })

    };

    // Run the function on resize
    jQuery( window ).resize(function()  {
        adjustToFullWidthRow();
    });

    // And run the function on dom ready
    adjustToFullWidthRow();

})
*/
